module.exports = __webpack_public_path__ + "static/media/rfm.32e921b7.png";